export default () => window?.matchMedia && window.matchMedia('(max-width: 480px)').matches;
